import Value from './SubscribeSection'

export default {
	label: 'Subscribe form',
	group: 'forms',
	Value,
}
